module.exports = __webpack_public_path__ + "static/media/19ESCAP14.97b83c8e.jpg";